import { render } from "./postCode.vue?vue&type=template&id=71609dae&scoped=true"
import script from "./postCode.vue?vue&type=script&lang=js"
export * from "./postCode.vue?vue&type=script&lang=js"

import "./postCode.vue?vue&type=style&index=0&id=71609dae&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71609dae"]])

export default __exports__